import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { getLearningTopicsBySlug } from '../api';
import Navbar from './Navbar';

export default function LearningTopics() {
  const navigate = useNavigate();
  const { moduleSlug } = useParams();
  const location = useLocation();
  const moduleTitle = location.state?.moduleTitle || moduleSlug;
  const [topics, setTopics] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);
    getLearningTopicsBySlug(moduleSlug)
      .then(res => setTopics(res.data.topics))
      .catch(err => {
        setError('Fehler beim Laden der Themen.');
        console.error('DEBUG Fehler beim Laden der Themen:', err);
      })
      .finally(() => setLoading(false));
  }, [moduleSlug]);

  const handleTopicClick = (topic) => {
    navigate(`/learning/${moduleSlug}/${topic.slug}`, {
      state: { moduleTitle, topicTitle: topic.title }
    });
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/login', { replace: true });
  };

  const handleStatistikClick = () => {
    navigate('/statistik');
  };

  const handleAccountClick = () => {
    navigate('/account');
  };

  const handleBackToLearning = () => {
    navigate('/learning');
  };

  if (loading) return <div className="learning-topics">Lade Themen...</div>;
  if (error) return <div className="learning-topics" style={{color:'#c33'}}>{error}</div>;

  return (
    <div className="learning-topics">
      <div className="background" />
      <Navbar 
        title={`${moduleTitle} – Lernthemen`}
        onLogout={handleLogout}
        logoClickable={true}
        onLogoClick={handleBackToLearning}
        onStatistikClick={handleStatistikClick}
        onAccountClick={handleAccountClick}
      />
      <div className="learning-content">
        <div className="learning-container">
          <div className="learning-header">
            <h2>Wählen Sie ein Lernthema</h2>
            <p>Klicken Sie auf ein Thema, um das Quiz zu starten</p>
          </div>
          {/* Statt modules-grid jetzt eine vertikale Liste */}
          <div className="topics-list">
            {topics.map(topic => (
              <div 
                key={topic.slug} 
                className="topic-card"
                onClick={() => handleTopicClick(topic)}
                tabIndex={0}
                role="button"
                onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') handleTopicClick(topic); }}
              >
                <div className="topic-card-row topic-card-row-top">
                  <div className="topic-card-title">{topic.title}</div>
                  <div className="topic-card-description">{topic.description}</div>
                </div>
                <div className="topic-card-row topic-card-row-image">
                  <div className="topic-card-image-wrapper">
                    <img src={topic.image || '/images/placeholder.png'} alt={topic.title} className="topic-card-image" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
} 